import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Caption, TinyTitleBold, mq } from '@kvdbil/components';
import Media from '~/App/shared/components/Media';
import { ProcessedAuction } from '../../interfaces/ProcessedAuction';
import { Close } from '../IconButtons/Close';

interface ContainerProps {
  isBiddingView: boolean;
  isBiddingGuideOpen: boolean;
}
const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-bottom: 1rem;

  ${({ isBiddingView }) =>
    !isBiddingView &&
    css`
      padding: 1rem 2rem 1rem 2rem;
    `}

  ${({ isBiddingGuideOpen }) =>
    isBiddingGuideOpen &&
    css`
      margin-bottom: 4rem;

      ${mq(null, 'mobileL')} {
        margin-bottom: 9rem;
      }
      ${mq('laptop')} {
        margin-bottom: 4rem;
      }
    `};
`;

const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
`;

const AuctionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  figure {
    overflow: hidden;
    width: 6rem;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  & button {
    text-align: left;
  }
`;

interface Props {
  auction: ProcessedAuction;
  isBiddingView?: boolean;
  isBiddingGuideOpen: boolean;
  image: string;
  imageAltText: string;
  auctionIsClosed: boolean;
  closeBiddingView?(): void;
  children?: ReactNode;
}
const ObjectSummaryRow = ({
  image,
  auction,
  imageAltText,
  closeBiddingView,
  isBiddingGuideOpen,
  isBiddingView = true,
  children
}: Props) => {
  return (
    <Container
      isBiddingView={isBiddingView}
      isBiddingGuideOpen={isBiddingGuideOpen}
    >
      <CloseButtonContainer>
        <Close onClick={closeBiddingView} />
      </CloseButtonContainer>

      <Top>
        <AuctionInfo>
          <Media ratio={8 / 5} src={image} alt={imageAltText} />
          <Content>
            <TinyTitleBold>{auction.processObject.heading1}</TinyTitleBold>
            <Caption>
              {auction.processObject.heading2} {auction.processObject.heading3}
            </Caption>
          </Content>
        </AuctionInfo>
      </Top>

      {children}
    </Container>
  );
};

export default ObjectSummaryRow;
